import rating from './rating'
import search from './search'
import comment from './comment'
import {
  API,
  Request,
  setCookie,
  getCookie
} from '@/lib/index.js'
let sessionTarget = window.localStorage.getItem('sessionTarget')
export default {
  modules: {
    search,
    rating,
    comment
  },
  state: {
    userInfo: {},
    navList: [],
    noticeList: [],
    noticeCount: 0,
    categoryId: undefined,
    childCategoryId: undefined,
    count: 1,
    localCount: 200,
    isLogin: false,
    sessionTarget: sessionTarget && Number(sessionTarget) || 2,
    versions: [
      {
        label: 'MP商家',
        value: 1
      },
      {
        label: '自营供应商',
        value: 2
      }
    ],
    noticeInfo: {},
    recommendationList: [],
    myCoursesList: [],
    myCoursesListCount: 0,
    categoryList: [],
    courseOverviewsList: [],
    courseOverviewsCount: 0,
    courseDetail: {},
    chapterDetail: {},
    primaryCategoryId: 0,
    queryUserPromise: null,
    examsList: [],
    myExamsList: [],
    examOfCourseList: []
  },
  mutations: {
    async updateSessionTarget (state, payload) {
      // console.log('updateSessionTarget', payload)
      window.localStorage.setItem('sessionTarget', payload)
      state.sessionTarget = payload
      // window.location.reload()
    },
    updateNavs (state, payload) {
      state.navList = payload
    },
    updateNoticeList (state, payload) {
      let noticeList = []
      let temp = []
      payload.forEach((item, index) => {
        if (temp.length < 2) {
          temp.push(item)
          if (temp.length === 2 || (payload.length - 1 === index)) {
            noticeList.push(JSON.parse(JSON.stringify(temp)))
            temp = []
          }
        }
      })
      state.noticeList = noticeList
    },
    updateCategoryId (state, payload) {
      state.categoryId = payload.categoryId
      state.childCategoryId = payload.childCategoryId
    },
    updateUserInfo (state, payload) {
      state.userInfo = payload
      window.userInfo = payload
    },
    updateLoginState(state, payload)  {
      state.isLogin = payload
    },
    incrementTest (state, payload) {
      // 变更状态
      state.count += (payload | 1)
    },
    updateNoticeInfo (state, payload) {
      state.noticeInfo = payload || {}
    },
    updateNoticeCount (state, payload) {
      state.noticeCount = payload || 0
    },
    updateRecommendationList (state, payload) {
      state.recommendationList = payload || []
    },
    updateMyCoursesList (state, payload) {
      state.myCoursesList = payload || []
    },
    updateMyCoursesListCount (state, payload) {
      state.myCoursesListCount = payload || []
    },
    updateCategory (state, payload) {
      state.categoryList = payload && payload.children || []
    },
    updateCourseOverviewsList (state, payload) {
      state.courseOverviewsList = payload || []
    },
    updateCourseOverviewsCount (state, payload) {
      state.courseOverviewsCount = payload || 0
    },
    updateCourseDetail (state, payload) {
      let result = payload || {}
      state.courseDetail = JSON.parse(JSON.stringify(result))
    },
    updateCourseDetailLike (state, payload) {
      let courseDetail = JSON.parse(JSON.stringify(state.courseDetail))
      courseDetail.liked = payload
      state.courseDetail = courseDetail || {}
    },
    updateChapterDetail (state, payload) {
      state.chapterDetail = JSON.parse(JSON.stringify(payload))
    },
    updatePrimaryCategoryId (state, payload) {
      state.primaryCategoryId = payload
    },
    updateExamsList (state, payload) {
      state.examsList = payload
    },
    updateMyExamsList (state, payload) {
      state.myExamsList = payload
    },
    updateExamOfCourse (state, payload) {
      state.examOfCourseList = payload
    },
  },
  getters: {
    getCount (state, getters) {
      return state.count + getters.getersTest
    },
    getersTest (state) {
      return state.localCount
    },
    getSessionTargetLabel (state) {
      let result = state.versions.find((item) => item.value === state.sessionTarget) || state.versions[0]
      return result.label
    }
  },
  actions: {
    goQueryUser (store, payload) {
      const {
        target,
        sessionTarget
      } = payload
      setCookie('XSRF-TOKEN', '', -1, 'vip.com')
      setCookie('XSRF-TOKEN', '', -1, 'school.vip.com')
      store.state.queryUserPromise = new Promise((resolve, reject) => {
        store.dispatch('queryUser').then((resp) => {
          setCookie('reload', 'true', -1)
          let identities = resp.identities || []
          // let hasMember = identities.find((item) => item.code === 'MEMBER') // 会员
          let hasVendor = identities.find((item) => item.code === 'VENDOR') // 供应商
          let hasMerchant = identities.find((item) => item.code === 'MERCHANT') // 商家
          // let hasStaff = identities.find((item) => item.code === 'STAFF')  // 员工
          if (target || sessionTarget) {
            store.commit('updateSessionTarget', target || sessionTarget)
          } else if (hasVendor) {
            store.commit('updateSessionTarget', 2)
          } else if (hasMerchant) {
            store.commit('updateSessionTarget', 1)
          } else {
            store.commit('updateSessionTarget', 2)
          }
          resolve(true)
        }).catch(() => {
          if (!getCookie('reload')) {
            setCookie('reload', 'true', 24 * 3600 * 1000)
            window.location.href = `https://passport.vip.com/logout?src=${window.encodeURIComponent(window.location.href)}`
          }
          reject(true)
        })
      })
    },
    queryUser ({commit}) {
      return new Promise((resolve, reject) => {
        Request(API.queryUser, {}).then((resp) => {
          const result = resp
          resolve(result || {})
          if (result) {
            if (resp.castgc) {
              setCookie('school_token', resp.castgc, 8 * 3600 * 1000, 'vip.com')
              // 1 是通过castgc登录 2是passport登录
              setCookie('school_login_type', '1', 8 * 1000, 'vip.com')
              window.sessionStorage.setItem('school_login_type', '1')
            } else {
              setCookie('school_token', '', -1, 'vip.com')
            }
            (resp.uid || getCookie('VipRUID')) && setCookie('school_uid', (resp.uid || getCookie('VipRUID')), 24 * 3600 * 1000, 'vip.com')
          } else {
            setCookie('school_token', '', -1, 'vip.com')
            setCookie('school_uid', '', -1, 'vip.com')
            setCookie('school_login_type', '', -1, 'vip.com')
          }
          commit('updateUserInfo', result || {
            username: '',
            avatarUrl: '',
            identities: []
          })
        }).catch(() => {
          setCookie('school_token', '', -1, 'vip.com')
          setCookie('school_uid', '', -1, 'vip.com')
          setCookie('school_login_type', '', -1, 'vip.com')
          reject({})
        })
      })
    },
    queryNoticeOverviewCount ({commit}) {
      return new Promise((resolve) => {
        Request(API.queryNoticeOverviewCount, {
        }).then((resp) => {
          commit('updateNoticeCount', resp)
          resolve(resp)
        })
      })
    },
    queryNoticeOverviews ({commit}, pageDTO) {
      commit('updateNoticeList', [])
      return new Promise((resolve) => {
        Request(API.queryNoticeOverviews, {
          pageDTO
        }).then((resp) => {
          let result = resp || []
          commit('updateNoticeList', result)
          resolve(resp)
        }).catch(() => {
          resolve([])
        })
      })
    },
    queryRecommendationDetails ({commit}, type) {
      return new Promise((resolve, reject) => {
        Request(API.queryRecommendationDetails, {
          type
        }).then((resp) => {
          let result = resp || []
          commit('updateRecommendationList', result)
          resolve(result)
        }).catch(() => {
          reject([])
        })
      })
    },
    queryNoticeDetail ({commit}, noticeId) {
      return new Promise((resolve) => {
        Request(API.queryNoticeDetail, {
          noticeId
        }).then((resp) => {
          commit('updateNoticeInfo', resp)
          resolve(resp)
        })
      })
    },
    queryMyCourses ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryMyCourses, {
          completed: payload.completed, // 0-学习中、1-已学完,
          pageDTO: {
            pageNo: payload.pageNo || 1,
            pageSize: payload.pageSize || 9
          }
        }).then((resp) => {
          commit('updateMyCoursesList', resp)
          resolve(resp)
        }).catch(() => {
          reject()
        })
      })
    },
    queryMyCourseCount ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryMyCourseCount, {
          completed: payload.completed // 0-学习中、1-已学完,
        }).then((resp) => {
          commit('updateMyCoursesListCount', resp)
          resolve(resp)
        }).catch(() => {
          reject()
        })
      })
    },
    queryCategoryTree ({state, commit}, payload) {
      return new Promise((resolve) => {
        if (!payload && state.categoryList.length) {
          resolve({
            children: state.categoryList
          })
          return
        }
        Request(API.queryCategoryTree, {
        }).then((resp) => {
          commit('updateCategory', resp)
          resolve(resp)
        })
      })
    },
    queryCourseOverviews ({commit}, payload) {
      const {
        categoryId,
        pageNo,
        pageSize,
        sortType
      } = payload
      commit('updateCourseOverviewsList', [])
      return new Promise((resolve, reject) => {
        Request(API.queryCourseOverviews, {
          categoryId,
          page: {
            pageNo,
            pageSize
          },
          sortType
        }).then((resp) => {
          commit('updateCourseOverviewsList', resp)
          resolve(resp)
        }).catch(() => {
          reject()
        })
      })
    },
    queryCourseCount ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryCourseCount, {
          categoryId: payload
        }).then((resp) => {
          commit('updateCourseOverviewsCount', resp)
          resolve(resp)
        }).catch(() => {
          reject()
        })
      })
    },
    queryCourseDetail ({commit}, payload) {
      return new Promise((resolve) => {
        Request(API.queryCourseDetail, {
          courseId: payload
        }).then((resp) => {
          resp.richText = resp.richText && resp.richText.replace(/[\n\r]/g, '</br>').replace(/\n/g, '</br>').replace(/\s/g, '&nbsp;') || ''
          commit('updatePrimaryCategoryId', resp.primaryCategoryId || 0)
          commit('updateCourseDetail', resp)
          resolve(resp)
        })
      })
    },
    like ({commit}, payload) {
      return new Promise((resolve) => {
        Request(API.like, {
          courseId: payload.courseId,
          likeOrNot: payload.likeOrNot// 1-我喜欢，0-不喜欢，null-取消
        }).then((resp) => {
          commit('updateCourseDetailLike', resp)
          resolve(resp)
        })
      })
    },
    queryChapter ({commit}, payload) {
      const {
        courseId,
        chapterId
      } = payload
      return new Promise((resolve) => {
        Request(API.queryChapter, {
          courseId,
          chapterId
        }).then((resp) => {
          commit('updatePrimaryCategoryId', resp.primaryCategoryId || 0)
          commit('updateChapterDetail', resp)
          resolve(resp)
        })
      })
    },
    studyChapter ({commit}, payload) {
      const {
        courseId,
        chapterId,
        completed
      } = payload
      return new Promise((resolve) => {
        Request(API.studyChapter, {
          studyStatusDTO: {
            courseId,
            chapterId,
            completed // 是否学习完成，0-学习中、1-学习完成
          }
        }).then((resp) => {
          console.log(1, 'studyChapter', commit, resp)
          resolve(resp)
        })
      })
    },
    getNoticeOverview ({commit}, payload) {
      const {
        pageNo,
        pageSize
      } = payload
      return new Promise((resolve, reject) => {
        Request(API.getNoticeOverview, {
          categoryId: null,
          page: {
            pageNo,
            pageSize
          }
        }).then((resp) => {
          const result = resp || []
          resolve(true)
          commit('updateNoticeList', result)
        }).catch(() => {
          reject()
        })
      })
    },
    signout () {
      return new Promise((resolve, reject) => {
        Request(API.signout, {}).then((resp) => {
          resolve(resp)
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    queryExams ({commit}) {
      return new Promise((resolve, reject) => {
        Request(API.queryExams, {}).then((resp) => {
          const result = resp || [] || [getExam(), getExam()]
          resolve(true)
          commit('updateExamsList', result)
        }).catch(() => {
          reject()
        })
      })
    },
    queryMyExams ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryMyExams, {
          condition: {
            finished: payload
          }
        }).then((resp) => {
          const result = resp || []
          resolve(result)
          commit('updateMyExamsList', result)
        }).catch(() => {
          reject()
        })
      })
    },
    queryByCourseId ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryByCourseId, {
          courseId: payload
        }).then((resp) => {
          const result = resp || []
          resolve(result)
          commit('updateExamOfCourse', result)
        }).catch(() => {
          reject()
        })
      })
    },
    increment (context, payload) {
      context.commit('incrementTest', payload)
    },
  }
}

function getExam () {
  return {
    examId: '考试ID', // Long 可选 考试ID
    title: '考试标题', // String 可选 考试标题
    passScore: '100', // Integer 可选 及格分数
    totalScore: '100', // Integer 可选 总分
    passed: Math.floor(Math.random() * 2), // Byte 可选 是否通过，0-未通过、1-已通过
    examNo: '考试编号', // String 可选 考试编号
    questionCount: '111', // Integer 可选 题目数量
    duration: '111', // Integer 可选 时长
    deadline: Date.now(), // Date 可选 截止时间
    finishCount: '111', // Integer 可选 交卷人数
    analysisUrl: 'https://www.vip.com', // String 可选 答题解析URL
    examUrl: 'https://www.vip.com', // String 可选 考试URL
    makeupCount: '111', // Integer 可选 可补考次数
    privileged: Math.floor(Math.random() * 2) // Byte 可选 是否有权限，0-没有、1-有
  }
}
